/* eslint-disable vue/multi-word-component-names */
import Vue from 'vue'
import { 
  TrashCan,
  Refresh,
  RefreshTwo,
  ArrowLeftL,
  ArrowRightS,
  Pen,
  DocPen, 
  SymbolTick,
  SymbolCrossTwo,
  Eye,
  EyeClose,
  Dragging,
  Copy,
  ApFormatS,
  Save,
  ArrowRecover,
  ChartMindMap,
  ChangeToPicTwo,
  ImportMd,
  SymbolCross,
  ArrowTriangleRight,
  ScreenExpand,
  More,
  SidebarCollapse,
  SidebarExpand,
  LockTwoNormal,
} from '@kdocs/kdesign-icons-vue'

Vue.component('TrashCan', TrashCan)
Vue.component('Refresh', Refresh)
Vue.component('RefreshTwo', RefreshTwo)
Vue.component('ArrowLeftL', ArrowLeftL)
Vue.component('ArrowRightS', ArrowRightS)
Vue.component('Pen', Pen)
Vue.component('DocPen', DocPen)
Vue.component('SymbolTick', SymbolTick)
Vue.component('SymbolCrossTwo', SymbolCrossTwo)
Vue.component('Eye', Eye)
Vue.component('EyeClose', EyeClose)
Vue.component('Dragging', Dragging)
Vue.component('Copy', Copy)
Vue.component('ApFormatS', ApFormatS)
Vue.component('Save', Save)
Vue.component('ArrowRecover', ArrowRecover)
Vue.component('ChartMindMap', ChartMindMap)
Vue.component('ChangeToPicTwo', ChangeToPicTwo)
Vue.component('ImportMd', ImportMd)
Vue.component('SymbolCross', SymbolCross)
Vue.component('ArrowTriangleRight', ArrowTriangleRight)
Vue.component('ScreenExpand', ScreenExpand)
Vue.component('More', More)
Vue.component('SidebarCollapse', SidebarCollapse)
Vue.component('SidebarExpand', SidebarExpand)
Vue.component('LockTwoNormal', LockTwoNormal)
